import React from 'react';
import { useTranslation } from 'react-i18next';

export interface VideoCardProps {
  video: any;
  onClick: () => void;
}

const isNew = (publishedAt: string) => {
  const published = new Date(publishedAt);
  const now = new Date();
  const diff = (now.getTime() - published.getTime()) / (1000 * 60 * 60 * 24);
  return diff < 7;
};

const VideoCard: React.FC<VideoCardProps> = ({ video, onClick }) => {
  const { t } = useTranslation();
  return (
    <div
      className="relative group cursor-pointer bg-[#18181b] rounded-xl overflow-hidden shadow-lg transition-transform duration-200 hover:scale-105 hover:shadow-2xl focus-within:ring-2 focus-within:ring-[#14F195]"
      tabIndex={0}
      aria-label={`Watch video: ${video.snippet.title}`}
      onClick={onClick}
      onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') onClick(); }}
    >
      <img
        src={video.snippet.thumbnails.high.url}
        alt={video.snippet.title}
        className="w-full h-48 object-cover group-hover:opacity-80 transition-opacity duration-200"
        loading="lazy"
      />
      {/* Play Icon Overlay */}
      <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-black/60 pointer-events-none">
        <svg width="48" height="48" viewBox="0 0 24 24" fill="#fff"><path d="M8 5v14l11-7z"/></svg>
      </div>
      {/* New Badge */}
      {isNew(video.snippet.publishedAt) && (
        <span className="absolute top-3 left-3 bg-[#14F195] text-black text-xs font-bold px-2 py-0.5 rounded-full shadow">{t('videos.newBadge', 'NEW')}</span>
      )}
      <div className="p-4">
        <h3 className="text-lg font-bold text-white mb-1 truncate" title={video.snippet.title}>{video.snippet.title}</h3>
        <p className="text-gray-400 text-sm mb-2 line-clamp-2">{video.snippet.description}</p>
        <span className="text-xs text-gray-300">{new Date(video.snippet.publishedAt).toLocaleDateString()}</span>
      </div>
    </div>
  );
};

export default VideoCard; 